import makeService from './api';

export default makeService('customer_tags');
